import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requiredModule = null }) {
  const { currentUser, userRole, canAccessModule } = useAuth();

  // If not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If no specific module required, just check if authenticated
  if (!requiredModule) {
    return children;
  }

  // Check if user can access the required module
  if (!canAccessModule(requiredModule)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h2>
          <p className="text-gray-600">You don't have permission to access this module.</p>
        </div>
      </div>
    );
  }

  return children;
}
